import apiClient from '../../data/repositories/apiClient.js';
import { storageService } from './StorageService.js';
import { uploadFile } from '../useCases/Upload/uploadFile.js';

export const BusinessClaimService = {
  /**
   * Search for businesses
   */
  searchBusinesses: async (params) => {
    try {
      const {
        query,
        page = 1,
        take = 10,
        distance = 80000,
        maxRating = 5,
        sortByDistance = 'ASC',
        location,
      } = params;

      const searchParams = new URLSearchParams({
        page,
        take,
        tag: query,
        distance,
        maxRating,
        sortByDistance,
      });

      if (location) {
        searchParams.append('geoPoints[0]', location.lat);
        searchParams.append('geoPoints[1]', location.lng);
      }

      const token = storageService.getAuthToken();
      const response = await fetch(
        `https://api.kaha.com.np/main/api/v3/businesses?${searchParams.toString()}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        throw new Error('Failed to search businesses');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Failed to search businesses');
    }
  },

  /**
   * Upload document file
   */
  uploadDocument: async (file) => {
    try {
      if (!file) {
        throw new Error('No file provided');
      }
      const url = await uploadFile(file);
      return url;
    } catch (error) {
      throw new Error(error.message || 'Failed to upload document');
    }
  },

  /**
   * Submit a business claim
   */
  submitClaim: async (claimData) => {
    try {
      const token = storageService.getAuthToken();

      const payload = {
        claimReason: claimData.claimReason,
        businessId: claimData.businessId,
        description: claimData.description,
        phoneNumber: claimData.phoneNumber,
        emailAddress: claimData.emailAddress,
        businessRegistrationCertificate: claimData.businessRegistrationCertificate,
        panVatCertificate: claimData.panVatCertificate,
      };

      const response = await fetch(
        'https://api.kaha.com.np/main/api/v3/businesses/claim-business',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Failed to submit claim');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Failed to submit claim');
    }
  },

  /**
   * Get user's geolocation
   */
  getUserLocation: () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error('Geolocation not supported'));
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => {
          reject(error);
        }
      );
    });
  },
};
